import React from "react";

function RoundCheckSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_17_3078)">
        <path
          stroke="#A1A0A0"
          strokeWidth="1.067"
          d="M4.267 8.002l3.2 2.666 4.266-5.333M8 15.47A7.465 7.465 0 118 .538a7.465 7.465 0 010 14.93z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_17_3078">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default RoundCheckSvg;
